import React, { Component } from "react";
import "./Upload.css";
import Cross from "@safecv/assets/Images/cross.png";
import Modal from "react-modal";
import Dropzones from "./Dropzones";
import StateDropDownBar from "./StateDropDownBar";

const customStyles = {
  content: {
    padding: "0px",
    width: "52%",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

class Upload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disableUpload: true,
    };
  }

  updateError = (val) => {
    this.setState({ disableUpload: val });
  };
  render() {
    const {
      modalIsOpen,
      afterOpenModal,
      closeModal,
      updateModal,
      isOriginalPlan,
    } = this.props;
    return (
      <div className="row">

        <StateDropDownBar {...this.props} />

        <Modal
          isOpen={modalIsOpen}
          onAfterOpen={afterOpenModal}
          onRequestClose={closeModal}
          style={customStyles}
          ariaHideApp={false}
          contentLabel="Upload Modal"
        >
          <div className="row" id="bgcolor">
            <div className="col-sm-6" id="custom-padding">
              <h1 id="fsizeupload">Upload</h1>
            </div>
            <div className="col-sm-6" id="custom-styling">
              <img
                src={Cross}
                onClick={closeModal}
                alt="quit"
                className="crossStyle"
              />
            </div>
          </div>
          <Dropzones
            onFilesAdded={console.log}
            updateUploadedFile={this.props.updateUploadedFile}
            isOriginalPlan={isOriginalPlan}
            updateError={this.updateError}
            errorTriggered={this.state.disableUpload}
            isAdditionalIndex={this.props.isAdditional}
            supportDocVerify={false}
          />
          <hr></hr>
          <label id="upload-cancel" onClick={closeModal}>
            Cancel
          </label>
          <button
            className="upload-btn1"
            disabled={this.state.disableUpload}
            onClick={updateModal}
          >
            Upload
          </button>
        </Modal>
        <hr className="zero-padding line" />
      </div>
    );
  }
}

export default Upload;
